import React from "react";
import { Route } from "react-router-dom";
import { LayoutTemplateV2 } from "../components/Templates/LayoutTemplateV2";
import { HomeV2 } from "../components/Pages/HomeV2";
import { Inicio } from "../components/Pages/Inicio";
import { SearchClients } from "../components/Pages/SearchClients";
import { DispatcherCustomerRegisterV2 } from "../components/Pages/DispatcherCustomerRegisterV2 ";
import { ProtectedRoute } from "../components/Atoms/ProtectedRoute";
import { ProtectedClientRoute } from "../components/Atoms/ProtectedClientRoute";
import { StoreV2 } from "../components/Pages/StoreV2";
import { DeliveryV2 } from "../components/Pages/DeliveryV2";
import { PixCancellation } from "../components/Pages/PixCancellation";
import { TicketCancellation } from "../components/Pages/TicketCancellation";
import { ItineranteV2 } from "../components/Pages/ItineranteV2";

export const useAgendamentoRoutes = () => {
  return (
    <Route path="/agendamento" element={<LayoutTemplateV2 />}>
      <Route index element={<HomeV2 />} />

      <Route
        path="inicio"
        element={
          <ProtectedRoute>
            <Inicio />
          </ProtectedRoute>
        }
      />

      <Route path="buscar-cliente" element={<SearchClients />} />

      <Route path="cadastro-cliente" element={<DispatcherCustomerRegisterV2 />} />

      <Route
        path="loja"
        element={
          <ProtectedClientRoute>
            <StoreV2 />
          </ProtectedClientRoute>
        }
      />
      <Route
        path="domicilio"
        element={
          <ProtectedClientRoute>
            <DeliveryV2 />
          </ProtectedClientRoute>
        }
      />
      <Route path="itinerantes" index element={<ItineranteV2 />} />
      <Route
        path="pagamento/cancelamento-pix"
        index
        element={<PixCancellation />}
      />
      <Route
        path="pagamento/cancelamento-boleto"
        index
        element={<TicketCancellation />}
      />
    </Route>
  );
};
